//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {
  queryBatchSingleEnrollType,
  queryCurrentEnrollBatchEnrollType,
  updateEnrollType,
} from '@/https/enroll'
import {
  Radio,
  RadioGroup,
} from 'vant'
import { toast } from '@/utils/toast'
import {
  danger,
  success,
} from '@/utils/notify.js'

export default {
  components: {
    Radio,
    RadioGroup,
  },

  data () {
    return {
      currentEnrollType: '',
      enrollTypeList: [],
    }
  },

  async created () {
    await this.setEnrollList()
    await this.setCurrentEnrollType()
    if (this.enrollTypeList.length === 1) {
      this.currentEnrollType = this.enrollTypeList[0]?.key
    }
  },

  methods: {
    async setCurrentEnrollType () {
      const { data } = await queryCurrentEnrollBatchEnrollType({ pcdm: this.$route.query.pcdm })

      this.currentEnrollType = data || ''
    },

    async setEnrollList () {
      const { data } = await queryBatchSingleEnrollType({ pcdm: this.$route.query.pcdm })

      this.enrollTypeList = data || []
    },

    showDescription (item) {
      toast(item.bz)
    },

    chooseType (item) {
      this.currentEnrollType = item.key
    },

    handlerPreview () {
      this.$router.go(-1)
    },

    goEnroll (type) {
      this.$router.push({
        path: '/startEnroll',
        query: {
          ...this.$route.query,
          dzlbdm: this.currentEnrollType,
        },
      })
    },

    async nextStep () {
      if (!this.currentEnrollType) {
        toast('请选择报考单招类别')

        return
      }

      const { code, message } = await updateEnrollType({
        pcdm: this.$route.query.pcdm,
        dzlbdm: this.currentEnrollType,
      })

      if (+code === 0) {
        success('操作成功')
        this.goEnroll()
      } else {
        danger(message)
      }
    },
  },
}
